
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, int32_type, record_type, bool_type, class_type, obj_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class GanttTask extends Record {
    constructor(id, parent, text, details, start, end, type, open, customData) {
        super();
        this.id = id;
        this.parent = parent;
        this.text = text;
        this.details = details;
        this.start = start;
        this.end = end;
        this.type = type;
        this.open = open;
        this.customData = customData;
    }
}

export function GanttTask_$reflection() {
    return record_type("Feliz.ReactGantt.GanttTask", [], GanttTask, () => [["id", string_type], ["parent", obj_type], ["text", string_type], ["details", string_type], ["start", class_type("System.DateTime")], ["end", class_type("System.DateTime")], ["type", string_type], ["open", bool_type], ["customData", obj_type]]);
}

export class GanttTaskType extends Record {
    constructor(id, label) {
        super();
        this.id = id;
        this.label = label;
    }
}

export function GanttTaskType_$reflection() {
    return record_type("Feliz.ReactGantt.GanttTaskType", [], GanttTaskType, () => [["id", string_type], ["label", string_type]]);
}

export class GanttScale extends Record {
    constructor(unit, step, format) {
        super();
        this.unit = unit;
        this.step = (step | 0);
        this.format = format;
    }
}

export function GanttScale_$reflection() {
    return record_type("Feliz.ReactGantt.GanttScale", [], GanttScale, () => [["unit", string_type], ["step", int32_type], ["format", lambda_type(class_type("System.DateTime"), string_type)]]);
}

export class GanttColumn extends Record {
    constructor(id, header, flexgrow, cell) {
        super();
        this.id = id;
        this.header = header;
        this.flexgrow = (flexgrow | 0);
        this.cell = cell;
    }
}

export function GanttColumn_$reflection() {
    return record_type("Feliz.ReactGantt.GanttColumn", [], GanttColumn, () => [["id", string_type], ["header", string_type], ["flexgrow", int32_type], ["cell", obj_type]]);
}

export class GanttMarker extends Record {
    constructor(start, text, css) {
        super();
        this.start = start;
        this.text = text;
        this.css = css;
    }
}

export function GanttMarker_$reflection() {
    return record_type("Feliz.ReactGantt.GanttMarker", [], GanttMarker, () => [["start", class_type("System.DateTime")], ["text", string_type], ["css", string_type]]);
}

